import React, { useMemo } from 'react';
import { USER_ROLES } from 'utils/Constants';

import Avatar from 'components/Misc/Avatar';
import { Title } from 'components/Misc/Typography';

import { useMessengerStore } from 'store/useMessengerStore';

const Contact = ({ user }) => {
	// Use messenger's store
	const onContact = useMessengerStore(state => state.onContact);

	// Store contact's role
	const role = useMemo(() => USER_ROLES.find(r => r.value === user.role), [user]);

	// Handle pending contact
	const onClick = () => onContact({
		id: user.id,
		role: user.role,
		online: user.online,
		avatar: user.avatar,
		fullName: user.fullName
	});

	return (
		<div className="py-1 px-2 flex items-center space-x-2 hover:bg-neutral-50 dark:hover:bg-neutral-700 rounded-lg cursor-pointer transition-colors" onClick={onClick}>
			<Avatar
				small
				alt={user.fullName}
				src={user.avatar}
				online={user.online}
			/>

			<Title
				title={user.fullName}
				subtitle={role.name}
				className="flex-1"
			/>
		</div>
	);
};

export default Contact;